module.exports = __webpack_public_path__ + "static/media/1.7e912388.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/works/scummypoker/images/1.png
// module id = 162
// module chunks = 0